class SpotifyVideoPodcast extends HTMLElement {
    constructor() {
        super();

        this.openPopupBtns = this.querySelectorAll('.spotify-video-section-wrapper--inner--image'); // Get all buttons
        this.popupOverlay = this.querySelector('.popup-overlay');
        this.closePopupBtn = this.querySelector('.close-popup');
        this.videoContainer = this.querySelector('.spotify-video-section-popup-wrapper');

        this.setupEventListeners();
    }

    setupEventListeners() {
        if (this.openPopupBtns.length > 0 && this.popupOverlay && this.closePopupBtn) {
            this.openPopupBtns.forEach(button => {
                button.addEventListener('click', (event) => {

                    const url = event.currentTarget.dataset.videoUrl;
                    if (!url) {
                        console.error('Error: No video URL found.');
                        return;
                    }

                    const parts = url.split("episode/");
                    if (parts.length < 2) {
                        console.error('Error: Invalid Spotify URL format.');
                        return;
                    }

                    const idPart = parts[1].split("?");
                    const videoId = idPart[0];

                    // Clear previous iframe if exists
                    this.videoContainer.innerHTML = '';

                    // Create iframe element properly
                    const iframe = document.createElement('iframe');
                    iframe.style.borderRadius = "12px";
                    iframe.src = `https://open.spotify.com/embed/episode/${videoId}/video?utm_source=generator`;
                    iframe.width = "624";
                    iframe.height = "351";
                    iframe.frameBorder = "0";
                    iframe.allowFullscreen = true;
                    iframe.allow = "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture";
                    iframe.loading = "lazy";

                    this.videoContainer.appendChild(iframe);

                    this.popupOverlay.classList.add('active');
                });
            });

            this.closePopupBtn.addEventListener('click', () => {
                this.popupOverlay.classList.remove('active');
                this.videoContainer.innerHTML = '';
            });

            this.popupOverlay.addEventListener('click', (e) => {
                if (e.target === this.popupOverlay) {
                    this.popupOverlay.classList.remove('active');
                    this.videoContainer.innerHTML = '';
                }
            });
        } else {
            console.error('Error: One or more elements not found.');
        }
    }
}

customElements.define('spotify-video-podcast', SpotifyVideoPodcast);
